import React from "react";

import Svg, { Path, Circle } from "components/Svg";

const Back = props => (
	<Svg
		width={17 * props.scale}
		height={17 * props.scale}
		viewBox="0 0 103 103"
		fill="none"
	>
        <Circle cx="51.5" cy="51.5" r="47.5" stroke="white" stroke-width="8"/>
        <Circle r="6.5" transform="matrix(-1 0 0 1 78.5 52.5)" fill="white"/>
        <Circle r="6.5" transform="matrix(-1 0 0 1 59.5 52.5)" fill="white"/>
        <Circle r="6.5" transform="matrix(-1 0 0 1 40.5 52.5)" fill="white"/>
		<Path
			fill={props.fill || "white"}
			d="M17 52.5L27.5 58.1292V46.8708L17 52.5Z"
		/>
	</Svg>
);

export default Back;


// WEBPACK FOOTER //
// ./src/components/svgs/Back/index.js